import Image, { ImageProps } from "next/image";
import React from "react";

/**
 * Purpose - Function to check if image is coming from AEM so that we can rely on Next js default image optimization.
 * If the image is not from AEM, we will skip Next.js optimization to avoid issues
 * @param src
 * @returns
 */
const isAemUrl = (src: ImageProps["src"]): src is string => {
  if (typeof src !== "string") return false;
  try {
    const url = new URL(src);
    return url.hostname.includes("aem") || url.hostname.includes("adobe");
  } catch {
    return false;
  }
};

const isExternalUrl = (src: ImageProps["src"]): src is string => {
  return typeof src === "string" && /^https?:\/\//.test(src);
};

const ImageWrapper: React.FC<ImageProps> = (props) => {
  const { src, alt = "", ...rest } = props;

  const shouldUnoptimize = isExternalUrl(src) && !isAemUrl(src);

  return (
    <Image
      src={src}
      alt={alt}
      {...rest}
      unoptimized={shouldUnoptimize} // Optimize AEM, skip others
    />
  );
};

export default ImageWrapper;
